import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

/**
 * BlogArticle functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class BlogArticle {
  /**
     * Constructs a new BlogArticle instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor (options) {
    this.element = options.element
    this.globalDuration = options.globalDuration
    this.columns = this.element.querySelectorAll('.column')
    // this.fbShareBtn = this.element.querySelector('[data-component="fb-share"]')
    // this.fbShareTitle = this.fbShareBtn.dataset.title
    // this.FBDesc = document.querySelector('meta[property="og:description"]').getAttribute('content')
    // this.fbShareLink = this.fbShareBtn.dataset.url
    // this.FBImage = document.querySelector('meta[property="og:image"]').getAttribute('content')

    var blogArticleTL = gsap.timeline({ paused: true })
    blogArticleTL.to(this.columns, { duration: 0.5, autoAlpha: 1, stagger: 0.25 })

    ScrollTrigger.create({
      trigger: this.element,
      start: 'top bottom',
      markers: false,
      scroller: 'body',
      onEnter: () => {
        blogArticleTL.play()
      }
    })

    // FB Share Button click event
    // this.fbShareBtn.addEventListener('click', e => {
    //   FB.ui({
    //     method: 'share',
    //     action_type: 'og.shares',
    //     action_properties: JSON.stringify({
    //       object: {
    //         'og:url': this.fbShareLink,
    //         'og:title': this.fbShareTitle
    //         // 'og:description': this.FBDesc,
    //         // 'og:image': this.FBImage
    //       }
    //     })
    //   },
    //   function (response) { // Action after response
    //   })
    // })
  }
}



// WEBPACK FOOTER //
// ./components/section/blog-article/index.js